import React from 'react';

import { Button, IconDownloadedFile } from '@trqk/components';
import { locale, getFilenameFromPath } from '@trqk/utils';

export const DetectionDownloadReady = ({
    remove,
    input,
}: ToastRenderContentProps<{
    downloadUrl: string;
}>): JSX.Element => {
    const downloadUrl = input?.downloadUrl ?? null;
    const defaultFilename = `${
        locale.enUS.TOASTS.DETECTION_DOWNLOAD_READY.DEFAULT_REPORT_NAME
    }.${Date.now()}.zip`;

    const filename =
        downloadUrl !== null
            ? getFilenameFromPath(downloadUrl)
            : defaultFilename;

    return (
        <div className="px-2" style={{ width: 400 }}>
            <div className="mb-6 font-medium">
                {locale.enUS.TOASTS.DETECTION_DOWNLOAD_READY.REPORT_IS_READY}
            </div>
            <div className="flex items-center mb-6">
                <IconDownloadedFile width={40} fillColor="primary-500" />
                <p className="ml-2 text-sm break-all">{filename}</p>
            </div>
            <div className="mb-2">
                {downloadUrl && (
                    <a
                        className="px-2"
                        href={downloadUrl}
                        download={filename}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            autoWidth={true}
                            color="primary-light-bg"
                            handleClick={() => {
                                remove();
                            }}
                        >
                            {
                                locale.enUS.TOASTS.DETECTION_DOWNLOAD_READY
                                    .DOWNLOAD_REPORT
                            }
                        </Button>
                    </a>
                )}
            </div>
        </div>
    );
};
